exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".MyMedias-local__myMedias--k1aaD {\n  padding-top: 8.625rem;\n  background-color: #29394e; }\n\n.MyMedias-local__header--3ay3Z {\n  padding: 0 1.325rem; }\n\n.MyMedias-local__body--3tKlJ {\n  padding: 0 5.125rem; }\n\n.MyMedias-local__medias--8mEI8 {\n  padding: 2rem 0; }\n", ""]);

// exports
exports.locals = {
	"myMedias": "MyMedias-local__myMedias--k1aaD",
	"header": "MyMedias-local__header--3ay3Z",
	"body": "MyMedias-local__body--3tKlJ",
	"medias": "MyMedias-local__medias--8mEI8"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/media/media/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/MyMedias/MyMedias.local.scss
// module id = 521
// module chunks = 0